<template>
  <section id="hero">
    <v-parallax dark height="950" src="@/assets/img/bgHero.jpg">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="6" xl="8">
              <h1 class="display-2 font-weight-bold mb-4">BB-SMILE</h1>
              <h1 class="font-weight-bold">
                Blockchain-Based Smart Methodologies <br>
                for Innovative Ledger Environments
              </h1>
              <h3 class="font-weight-light mt-6 description">
                A university startup from Sapienza and Unimol that operates as a center of expertise on Blockchain and
                AI
                technologies by integrating the operational skills
                of technology partners with the research and development knowledge of academic partners.
              </h3>

              <v-col>
                <v-row align="center" class="pt-4 pb-4 hidden-sm-and-down" justify="start">
                  <v-img alt="Logo Unimol" class="mt-2 mb-2 mr-2" max-height="130" max-width="220"
                         src="@/assets/img/unimol-with-text.png"/>
                  <v-img alt="Logo Sapienza" class="mt-2 mb-2 ml-2" max-height="130" max-width="220"
                         src="@/assets/img/sapienza-with-text.png"/>
                </v-row>
                <v-row align="center" class="pt-4 pb-4 hidden-md-and-up" justify="start">
                  <v-img alt="Logo Unimol" class="mt-2 mb-2 mr-2" max-height="130" max-width="120"
                         src="@/assets/img/unimol.png"/>
                  <v-img alt="Logo Sapienza" class="mt-2 mb-2 ml-2" max-height="130" max-width="100"
                         src="@/assets/img/sapienza.png"/>
                </v-row>
              </v-col>

              <v-btn
                  class="mt-2"
                  dark
                  large
                  outlined
                  rounded
                  @click="$vuetify.goTo('#features')"
              >
                Find out more
                <v-icon class="ml-2">mdi-arrow-down</v-icon>
              </v-btn>
            </v-col>
            <v-col class="hidden-sm-and-down" cols="12" md="6" xl="4"></v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="svg-border-waves text-white">
        <v-img src="@/assets/img/borderWaves.svg"/>
      </div>
    </v-parallax>
    <v-container id="features" class="mt-2" fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="space-around">
            <v-col
                v-for="(feature, i) in features"
                :key="i"
                class="text-center"
                cols="12"
                sm="4"
            >
              <v-hover v-slot:default="{ hover }">
                <v-card
                    :class="{ up: hover }"
                    :elevation="hover ? 10 : 4"
                    class="card"
                    shaped
                >
                  <v-img
                      :class="{ 'zoom-efect': hover }"
                      :src="feature.img"
                      class="d-block ml-auto mr-auto"
                      max-width="100px"
                  ></v-img>
                  <h1 class="font-weight-regular">{{ feature.title }}</h1>
                  <h4 class="font-weight-regular subtitle-1">
                    {{ feature.text }}
                  </h4>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-waves">
      <img src="~@/assets/img/wave2.svg"/>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      features: [
        {
          img: require("@/assets/img/strategy.png"),
          title: "Strategy",
          text: "Analysis of technologies and markets, verification of technical and scientific feasibility, production of sustainable roadmaps.",
        },
        {
          img: require("@/assets/img/workshop.png"),
          title: "Workshop",
          text: "Blockchain workshop to better understand blockchain technology and provide you with basic knowledge about its potential applications and features.",
        },
        {
          img: require("@/assets/img/technological-stack.png"),
          title: "Technological Stack",
          text: "Choice of blockchain services and tools to define a solution that fully satisfies the requirements of security, user use, and functionality.",
        },
        {
          img: require("@/assets/img/economy.png"),
          title: "Economy",
          text: "Scenario and functionality evaluation, cost calculation and resource allocation, dynamic budget management.",
        },
        {
          img: require("@/assets/img/enterprise.png"),
          title: "Enterprise",
          text: "Definition of the project areas, expected results, prerequisite analysis, transfer of technological knowledge, structuring of the team.",
        },
      ],
    };
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss">
.description {
  word-wrap: break-word;
  max-width: 80%;
}

.circle {
  stroke: white;
  stroke-dasharray: 650;
  stroke-dashoffset: 650;
  -webkit-transition: all 0.5s ease-in-out;
  opacity: 0.3;
}

.playBut {
  /*  border: 1px solid red;*/
  display: inline-block;
  -webkit-transition: all 0.5s ease;

  .triangle {
    -webkit-transition: all 0.7s ease-in-out;
    stroke-dasharray: 240;
    stroke-dashoffset: 480;
    stroke: white;
    transform: translateY(0);
  }

  &:hover {
    .triangle {
      stroke-dashoffset: 0;
      opacity: 1;
      stroke: white;
      animation: nudge 0.7s ease-in-out;

      @keyframes nudge {
        0% {
          transform: translateX(0);
        }
        30% {
          transform: translateX(-5px);
        }
        50% {
          transform: translateX(5px);
        }
        70% {
          transform: translateX(-2px);
        }
        100% {
          transform: translateX(0);
        }
      }
    }

    .circle {
      stroke-dashoffset: 0;
      opacity: 1;
    }
  }
}
</style>

<style>
.btn-play {
  transition: 0.2s;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

#hero {
  z-index: 0;
}

.svg-border-waves img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: -1;
}

.card {
  min-height: 300px;
  padding: 10px;
  transition: 0.5s ease-out;
}

.card .v-image {
  margin-bottom: 15px;
  transition: 0.75s;
}

.card h1 {
  margin-bottom: 10px;
}

.zoom-efect {
  transform: scale(1.1);
}

.up {
  transform: translateY(-20px);
  transition: 0.5s ease-out;
}
</style>

<style>
section {
  position: relative;
}
</style>
